/* ============ LOCKER THEME V1 JS ============ */

function getCurrencySymbol() {
  var code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CAD';
  var map = { CAD: 'C$', USD: '$', EUR: '€', GBP: '£', AUD: 'A$', NZD: 'NZ$', JPY: '¥', BRL: 'R$' };
  return map[code] || (code + ' ');
}

// ============ ANNOUNCEMENT COUNTDOWN ============
(function() {
  const el = document.getElementById('ann-countdown');
  if (!el) return;
  const end = new Date(el.dataset.end).getTime();
  if (isNaN(end)) return;
  const days  = document.getElementById('ann-days');
  const hours = document.getElementById('ann-hours');
  const mins  = document.getElementById('ann-mins');
  const secs  = document.getElementById('ann-secs');
  function pad(n) { return String(Math.max(0, n)).padStart(2, '0'); }
  function tick() {
    const diff = end - Date.now();
    if (diff <= 0) { el.closest('.announce').remove(); return; }
    const d = Math.floor(diff / 86400000);
    const h = Math.floor((diff % 86400000) / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);
    if (days)  days.textContent  = pad(d);
    if (hours) hours.textContent = pad(h);
    if (mins)  mins.textContent  = pad(m);
    if (secs)  secs.textContent  = pad(s);
  }
  tick();
  setInterval(tick, 1000);
})();

// ============ MOBILE DRAWER ============
(function() {
  const drawer = document.getElementById('mobile-drawer');
  const overlay = document.getElementById('mobile-overlay');
  const openBtn = document.getElementById('open-menu');
  const closeBtn = document.getElementById('close-menu');
  if (!drawer) return;
  document.body.appendChild(drawer);
  function openMenu() { drawer.classList.add('open'); overlay.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeMenu() { drawer.classList.remove('open'); overlay.classList.remove('open'); document.body.style.overflow = ''; }
  if (openBtn) openBtn.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);
  document.querySelectorAll('.mobile-nav-trigger').forEach(t => {
    t.addEventListener('click', () => {
      const open = t.parentElement.classList.toggle('open');
      t.setAttribute('aria-expanded', open);
    });
  });
  document.querySelectorAll('.mobile-nav-col-trigger').forEach(t => {
    t.addEventListener('click', () => {
      const open = t.parentElement.classList.toggle('open');
      t.setAttribute('aria-expanded', open);
    });
  });
})();

// ============ HERO SLIDESHOW ============
(function() {
  const hero = document.querySelector('.hero');
  if (!hero) return;
  const slides = hero.querySelectorAll('.hero-slide');
  if (slides.length < 2) return;
  const dotsContainer = hero.querySelector('#hero-dots');
  const prevBtn = hero.querySelector('#hero-prev');
  const nextBtn = hero.querySelector('#hero-next');
  const pauseBtn = hero.querySelector('#hero-pause');
  let current = 0;
  let paused = false;
  let interval;
  const DELAY = 6000;

  // Build dots
  slides.forEach((_, i) => {
    const dot = document.createElement('button');
    dot.className = 'hero-dot' + (i === 0 ? ' active' : '');
    dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
    dot.innerHTML = '<span class="fill"></span>';
    dot.addEventListener('click', () => goTo(i));
    if (dotsContainer) dotsContainer.appendChild(dot);
  });

  function getDots() { return dotsContainer ? dotsContainer.querySelectorAll('.hero-dot') : []; }

  function goTo(idx) {
    slides[current].classList.remove('active');
    getDots()[current]?.classList.remove('active');
    current = (idx + slides.length) % slides.length;
    slides[current].classList.add('active');
    const dots = getDots();
    dots[current]?.classList.remove('active');
    void dots[current]?.offsetWidth; // force reflow to restart animation
    dots[current]?.classList.add('active');
  }

  function next() { goTo(current + 1); }
  function prev() { goTo(current - 1); }

  function startTimer() {
    clearInterval(interval);
    if (!paused) interval = setInterval(next, DELAY);
  }

  if (prevBtn) prevBtn.addEventListener('click', () => { prev(); startTimer(); });
  if (nextBtn) nextBtn.addEventListener('click', () => { next(); startTimer(); });
  if (pauseBtn) {
    pauseBtn.addEventListener('click', () => {
      paused = !paused;
      pauseBtn.classList.toggle('paused', paused);
      hero.classList.toggle('paused', paused);
      startTimer();
    });
  }

  // Swipe support
  let touchStartX = 0;
  hero.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
  hero.addEventListener('touchend', e => {
    const diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) { diff > 0 ? next() : prev(); startTimer(); }
  });

  // Responsive content alignment (tablet/mobile overrides from data attrs)
  const allSlides = hero.querySelectorAll('.hero-slide');
  function applyResponsiveAlign() {
    const w = window.innerWidth;
    allSlides.forEach(slide => {
      const t = slide.dataset.alignTablet;
      const m = slide.dataset.alignMobile;
      const override = w <= 560 ? m : w <= 968 ? t : '';
      if (override) {
        slide.classList.remove('text-left', 'text-center', 'text-right');
        slide.classList.add('text-' + override);
      }
    });
  }
  applyResponsiveAlign();
  window.addEventListener('resize', applyResponsiveAlign);

  startTimer();
})();

// ============ ACCORDION ============
document.querySelectorAll('.acc-trigger').forEach(trigger => {
  trigger.addEventListener('click', () => {
    trigger.parentElement.classList.toggle('open');
  });
});

// ============ PRODUCT PAGE ============
(function() {
  const data = window.ProductData;
  if (!data) return;

  const variantIdInput = document.getElementById('variant-id');
  const mainImg = document.getElementById('main-product-image');
  const priceEl = document.getElementById('product-price');
  const priceWasEl = document.getElementById('product-price-was');
  const priceSaveEl = document.getElementById('product-price-save');
  const priceTaxEl = document.getElementById('price-tax');
  const addCartBtn = document.getElementById('add-cart');
  const stockInfo  = document.getElementById('stock-info');
  const skuWrap    = document.getElementById('product-sku');
  const skuValue   = document.getElementById('product-sku-value');
  const invWarning = document.getElementById('inv-warning');
  const notifyWrap = document.getElementById('notify-wrap');
  const notifyField = document.getElementById('notify-field');
  const notifyConfirmed = document.getElementById('notify-confirmed');
  const notifyError = document.getElementById('notify-error');
  const omnisendFormWrap = document.getElementById('omnisend-form-wrap');
  if (omnisendFormWrap) {
    var omFormId = omnisendFormWrap.dataset.formId;
    function initOmnisendWidget() {
      window.omnisend = window.omnisend || [];
      window.omnisend.push(['embeddedWidget', omFormId]);
    }
    if (document.readyState === 'complete') {
      initOmnisendWidget();
    } else {
      window.addEventListener('load', initOmnisendWidget);
    }
  }
  const cartSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M3 3h2l2.4 12.3a2 2 0 0 0 2 1.7h9.4a2 2 0 0 0 2-1.7L23 6H6"/><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/></svg>';

  // Engraving state — read price from data attribute set by Liquid
  const customizeWrap = document.getElementById('customize');
  let engravingActive = false;
  const engravingCents = parseInt(customizeWrap?.dataset.engravingPrice) || 0;

  // Track selected option values by position (1-indexed)
  const selectedOptions = {};
  function isVarAvailable(v) {
    return data.variantAvailable ? !!data.variantAvailable[v.id] : v.available;
  }
  const initialVariant = data.variants.find(v => isVarAvailable(v)) || data.variants[0];
  if (initialVariant) {
    initialVariant.options.forEach((val, i) => { selectedOptions[i + 1] = val; });
  }

  // Track current gallery image index for arrow navigation
  let currentImgIndex = 0;
  let preEngravingImgIdx = 0;

  function money(cents) {
    return getCurrencySymbol() + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function getVariantStock(variant) {
    if (!variant) return Infinity;
    const inv = data.variantInventory && data.variantInventory[variant.id];
    if (!inv || inv.mgmt !== 'shopify') return Infinity;
    if (inv.policy === 'continue') return Infinity;
    return typeof inv.qty === 'number' ? inv.qty : Infinity;
  }

  function showInvWarning(msg) {
    if (invWarning) { invWarning.textContent = msg; invWarning.style.display = ''; }
  }
  function hideInvWarning() {
    if (invWarning) invWarning.style.display = 'none';
  }

  function findVariant() {
    return data.variants.find(v =>
      v.options.every((val, i) => selectedOptions[i + 1] === val)
    ) || null;
  }

  function setMainImage(src, alt, index) {
    currentImgIndex = index;
    if (mainImg) { mainImg.src = src; if (alt) mainImg.alt = alt; }
    document.querySelectorAll('#thumbs .thumb').forEach((t, i) => {
      t.classList.toggle('active', i === index);
    });
    const thumbsEl = document.getElementById('thumbs');
    const activeThumb = thumbsEl?.querySelector('.thumb.active');
    if (activeThumb) {
      activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      requestAnimationFrame(updateThumbNav);
    }
    document.querySelectorAll('#gallery-mobile-dots .mobile-dot').forEach((d, i) => {
      d.classList.toggle('active', i === index);
    });
  }

  function applyVariant(variant) {
    if (!variant) return;
    if (variantIdInput) variantIdInput.value = variant.id;

    // Keep buy-now form in sync
    const buyNowInput = document.getElementById('buy-now-variant-id');
    if (buyNowInput) buyNowInput.value = variant.id;

    // Add engraving cost to displayed price when toggle is on
    const displayCents = variant.price + (engravingActive ? engravingCents : 0);
    const price = money(displayCents);
    if (priceEl) priceEl.textContent = price;
    if (priceTaxEl) priceTaxEl.textContent = 'Tax & Shipping Calculated at checkout';

    const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    const compareAtDisplay = onSale ? variant.compare_at_price + (engravingActive ? engravingCents : 0) : null;
    if (priceWasEl) { priceWasEl.textContent = onSale ? money(compareAtDisplay) : ''; priceWasEl.style.display = onSale ? '' : 'none'; }
    if (priceSaveEl) priceSaveEl.style.display = onSale ? '' : 'none';

    const varAvailable = isVarAvailable(variant);
    if (addCartBtn) {
      addCartBtn.disabled = !varAvailable;
      addCartBtn.innerHTML = varAvailable ? cartSvg + ' Add to Cart — ' + price : 'Sold Out';
    }
    if (stockInfo) {
      stockInfo.style.display = varAvailable ? '' : 'none';
    }
    if (skuWrap) {
      skuWrap.style.display = variant.sku ? '' : 'none';
      if (skuValue) skuValue.textContent = variant.sku || '';
    }
    const _stock = getVariantStock(variant);
    const _qtyEl = document.getElementById('qty-input');
    if (_qtyEl) {
      if (_stock < Infinity) {
        _qtyEl.max = _stock;
        if (parseInt(_qtyEl.value) > _stock) _qtyEl.value = Math.max(1, _stock);
      } else {
        _qtyEl.removeAttribute('max');
      }
    }
    if (_stock <= 5 && _stock > 0) {
      showInvWarning('Only ' + _stock + ' left in stock!');
    } else {
      hideInvWarning();
    }
    if (omnisendFormWrap) {
      omnisendFormWrap.style.display = varAvailable ? 'none' : '';
    }
    if (notifyWrap) {
      notifyWrap.style.display = varAvailable ? 'none' : '';
      notifyWrap.dataset.variantId = variant.id;
      notifyWrap.dataset.variantTitle = variant.title;
      if (notifyField) notifyField.style.display = '';
      if (notifyConfirmed) notifyConfirmed.style.display = 'none';
      if (notifyError) notifyError.style.display = 'none';
      const emailEl = document.getElementById('notify-email');
      if (emailEl) emailEl.value = '';
    }

    if (engravingActive) {
      // When engraving is on, update to the engraving image for the newly selected variant
      var engImg = findEngravingImage(variant);
      if (engImg) {
        var engIdx = data.images.findIndex(function(img) { return img.id === engImg.id; });
        if (engIdx !== -1) setMainImage(data.images[engIdx].src, data.images[engIdx].alt, engIdx);
      }
    } else if (variant.featured_image) {
      const imgIdx = data.images.findIndex(img => img.id === variant.featured_image.id);
      if (imgIdx !== -1) {
        setMainImage(data.images[imgIdx].src, data.images[imgIdx].alt, imgIdx);
      }
    }
  }

  // Omnisend back-in-stock signup
  const notifyBtn = document.getElementById('notify-btn');
  if (notifyBtn && notifyWrap) {
    notifyBtn.addEventListener('click', function() {
      const emailEl = document.getElementById('notify-email');
      const email = emailEl ? emailEl.value.trim() : '';
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        if (notifyError) notifyError.style.display = '';
        return;
      }
      if (notifyError) notifyError.style.display = 'none';
      notifyBtn.disabled = true;
      notifyBtn.textContent = '...';
      const variantId = notifyWrap.dataset.variantId;
      // Routed only through Shopify's own /contact endpoint. This used to also
      // call Omnisend's REST API directly from the browser with a private
      // X-API-KEY, which meant anyone could view-source the page and steal
      // full read/write access to the Omnisend account. No secret key is
      // needed here; the merchant still gets notified, and Omnisend's own
      // Shopify integration syncs contacts/customers on its own.
      var fd = new FormData();
      fd.append('form_type', 'contact');
      fd.append('utf8', '✓');
      fd.append('contact[email]', email);
      fd.append('contact[name]', 'Back In Stock Alert');
      fd.append('contact[body]',
        '🔔 New back in stock request\n\n' +
        'Customer email: ' + email + '\n' +
        'Product: ' + notifyWrap.dataset.productTitle + '\n' +
        'Variant: ' + notifyWrap.dataset.variantTitle + '\n' +
        'Variant ID: ' + variantId + '\n' +
        'Product URL: ' + window.location.href
      );
      fetch('/contact', { method: 'POST', body: fd }).then(function(res) {
        if (res.ok) {
          if (notifyField) notifyField.style.display = 'none';
          if (notifyConfirmed) notifyConfirmed.style.display = '';
        } else {
          notifyBtn.disabled = false;
          notifyBtn.textContent = 'Notify Me';
          if (notifyError) { notifyError.textContent = 'Something went wrong. Please try again.'; notifyError.style.display = ''; }
        }
      }).catch(function() {
        notifyBtn.disabled = false;
        notifyBtn.textContent = 'Notify Me';
        if (notifyError) { notifyError.textContent = 'Something went wrong. Please try again.'; notifyError.style.display = ''; }
      });
    });
  }

  // Gallery prev/next arrows (standard layout — not carousel)
  const gPrev = document.getElementById('gallery-prev-btn');
  const gNext = document.getElementById('gallery-next-btn');
  if (gPrev) {
    gPrev.addEventListener('click', () => {
      const idx = (currentImgIndex - 1 + data.images.length) % data.images.length;
      setMainImage(data.images[idx].src, data.images[idx].alt, idx);
    });
  }
  if (gNext) {
    gNext.addEventListener('click', () => {
      const idx = (currentImgIndex + 1) % data.images.length;
      setMainImage(data.images[idx].src, data.images[idx].alt, idx);
    });
  }

  // Buy It Now → checkout (fallback when express checkout is not available)
  const buyNowBtn = document.getElementById('btn-buy-now');
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', async () => {
      const variantId = parseInt(document.getElementById('variant-id')?.value);
      const qty = parseInt(document.getElementById('qty-input')?.value) || 1;
      if (!variantId) { window.location.href = '/checkout'; return; }
      buyNowBtn.disabled = true;
      const origBuyNowText = buyNowBtn.textContent;
      buyNowBtn.textContent = '...';
      try {
        // Sent as FormData (not JSON.stringify + application/json): Meta's
        // in-app browser (Instagram/Facebook) mishandles fetch() calls with
        // a JSON body and silently fails them. FormData matches what a
        // native form POST sends and works reliably there. We also now
        // check res.ok before redirecting — previously a failed add still
        // redirected to /checkout, sending people to checkout without the
        // item they just tried to buy.
        const fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', qty);
        const res = await fetch('/cart/add.js', { method: 'POST', body: fd });
        if (!res.ok) throw new Error('add failed');
        window.location.href = '/checkout';
      } catch (_) {
        buyNowBtn.disabled = false;
        buyNowBtn.textContent = origBuyNowText;
        showInvWarning('Could not add to cart. Please try again.');
      }
    });
  }

  // Thumbnail clicks
  document.querySelectorAll('#thumbs .thumb').forEach((t, i) => {
    t.addEventListener('click', () => {
      setMainImage(t.dataset.imgSrc, t.dataset.imgAlt, i);
    });
  });

  // Thumbnail nav arrows (desktop left strip)
  const thumbsWrap = document.getElementById('thumbs-wrap');
  const thumbNavUp = document.getElementById('thumb-nav-up');
  const thumbNavDown = document.getElementById('thumb-nav-down');
  const thumbsScrollEl = document.getElementById('thumbs');

  function updateThumbNav() {
    if (!thumbsScrollEl || !thumbsWrap) return;
    const atTop = thumbsScrollEl.scrollTop <= 2;
    const atBottom = thumbsScrollEl.scrollTop + thumbsScrollEl.clientHeight >= thumbsScrollEl.scrollHeight - 2;
    if (thumbNavUp) thumbNavUp.hidden = atTop;
    if (thumbNavDown) thumbNavDown.hidden = atBottom;
    thumbsWrap.classList.toggle('fade-top', !atTop);
    thumbsWrap.classList.toggle('fade-bottom', !atBottom);
  }

  if (thumbsScrollEl) thumbsScrollEl.addEventListener('scroll', updateThumbNav, { passive: true });
  if (thumbNavUp) thumbNavUp.addEventListener('click', () => thumbsScrollEl.scrollBy({ top: -96, behavior: 'smooth' }));
  if (thumbNavDown) thumbNavDown.addEventListener('click', () => thumbsScrollEl.scrollBy({ top: 96, behavior: 'smooth' }));
  requestAnimationFrame(updateThumbNav);
  requestAnimationFrame(updateSizeAvailability);

  function updateSizeAvailability() {
    const sizeBtns = document.querySelectorAll('.size-option');
    if (!sizeBtns.length || !data.variants) return;
    sizeBtns.forEach(function(btn) {
      const sizeOptNum = parseInt(btn.dataset.option);
      const sizeVal = btn.dataset.size;
      const available = data.variants.some(function(v) {
        if (!isVarAvailable(v)) return false;
        return v.options.every(function(optVal, idx) {
          const pos = idx + 1;
          if (pos === sizeOptNum) return optVal === sizeVal;
          return !selectedOptions[pos] || selectedOptions[pos] === optVal;
        });
      });
      btn.classList.toggle('unavailable', !available);
      btn.setAttribute('aria-disabled', available ? 'false' : 'true');
    });
  }

  // Variant option buttons (swatches + size options)
  document.querySelectorAll('.swatch, .size-option').forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.classList.contains('unavailable')) return;
      const optNum = parseInt(btn.dataset.option);
      const value = btn.dataset.color || btn.dataset.size;
      selectedOptions[optNum] = value;

      // Update active state within this option group
      btn.closest('.swatches, .size-options')
        ?.querySelectorAll('.swatch, .size-option')
        .forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      // Update displayed label
      const labelEl = document.getElementById('option-' + optNum + '-value');
      if (labelEl) labelEl.textContent = value.toUpperCase();

      applyVariant(findVariant());
      updateSizeAvailability();
    });
  });

  // Customization toggle — updates price display when engraving is added/removed
  const customizeToggle = document.getElementById('customize-toggle');

  function findEngravingImage(variant) {
    if (!data.images || !data.images.length) return null;
    // Try to match engraving image to current variant title words
    if (variant && variant.title && variant.title !== 'Default Title') {
      var words = variant.title.toLowerCase().split(/[\s\/]+/);
      var variantMatch = data.images.find(function(img) {
        if (!img.alt) return false;
        var alt = img.alt.toLowerCase();
        return alt.indexOf('engraving') !== -1 && words.some(function(w) { return w.length > 2 && alt.indexOf(w) !== -1; });
      });
      if (variantMatch) return variantMatch;
    }
    // Fall back to any image tagged engraving-preview
    return data.images.find(function(img) { return img.alt && img.alt.toLowerCase().indexOf('engraving') !== -1; }) || null;
  }

  if (customizeToggle && customizeWrap) {
    customizeToggle.addEventListener('click', () => {
      engravingActive = customizeWrap.classList.toggle('active');
      if (!engravingActive) {
        const textEl = document.getElementById('custom-text');
        const previewEl = document.getElementById('custom-preview');
        const counterEl = document.getElementById('char-count');
        if (textEl) textEl.value = '';
        if (previewEl) previewEl.textContent = '';
        if (counterEl) { counterEl.textContent = '0 / 20'; counterEl.classList.remove('over'); }
        // Restore to the image that was showing before engraving was activated
        if (data.images[preEngravingImgIdx]) {
          setMainImage(data.images[preEngravingImgIdx].src, data.images[preEngravingImgIdx].alt, preEngravingImgIdx);
        }
        applyVariant(findVariant());
      } else {
        // Save current image index before switching to engraving preview
        preEngravingImgIdx = currentImgIndex;
        // Show engraving preview image
        var engImg = findEngravingImage(findVariant());
        if (engImg) {
          var idx = data.images.findIndex(function(img) { return img.id === engImg.id; });
          if (idx !== -1) setMainImage(data.images[idx].src, data.images[idx].alt, idx);
        }
        applyVariant(findVariant());
      }
    });
  }

  // Live engraving preview (auto-uppercase)
  function toTitleCase(str) {
    return str.replace(/\S+/g, w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
  }

  function currentEngravingStyle() {
    return document.querySelector('#styles .style-option.active')?.dataset.style || 'block';
  }

  function applyEngravingCase(val) {
    return currentEngravingStyle() === 'block' ? val.toUpperCase() : toTitleCase(val);
  }

  const customInput = document.getElementById('custom-text');
  if (customInput) {
    customInput.addEventListener('input', () => {
      const val = applyEngravingCase(customInput.value);
      customInput.value = val;
      const preview = document.getElementById('custom-preview');
      const counter = document.getElementById('char-count');
      if (preview) preview.textContent = val;
      if (counter) { counter.textContent = val.length + ' / 20'; counter.classList.toggle('over', val.length >= 20); }
    });
  }

  // Engraving style picker
  document.querySelectorAll('#styles .style-option').forEach(st => {
    st.addEventListener('click', () => {
      document.querySelectorAll('#styles .style-option').forEach(s => s.classList.remove('active'));
      st.classList.add('active');
      const preview = document.getElementById('custom-preview');
      const styleInput = document.getElementById('engraving-style-input');
      if (!preview) return;
      const fonts = { block: "'Fugaz One', sans-serif", script: "'Lobster', cursive" };
      const transforms = { block: 'uppercase', script: 'none' };
      const spacing = { block: '0.05em', script: '0.02em' };
      const s = st.dataset.style;
      preview.style.fontFamily = fonts[s] || '';
      preview.style.textTransform = transforms[s] || '';
      preview.style.letterSpacing = spacing[s] || '';
      if (styleInput) styleInput.value = st.textContent.trim();
      // Re-case any existing text when style switches
      if (customInput && customInput.value) {
        const recased = applyEngravingCase(customInput.value);
        customInput.value = recased;
        preview.textContent = recased;
      }
    });
  });

  // Quantity
  const qtyInput = document.getElementById('qty-input');
  if (qtyInput) {
    document.getElementById('qty-minus')?.addEventListener('click', () => {
      const cur = parseInt(qtyInput.value);
      if (cur > 1) {
        qtyInput.value = cur - 1;
        const stock = getVariantStock(findVariant());
        if (stock > 5 || stock === Infinity) hideInvWarning();
      }
    });
    document.getElementById('qty-plus')?.addEventListener('click', () => {
      const stock = getVariantStock(findVariant());
      const next = parseInt(qtyInput.value) + 1;
      if (stock < Infinity && next > stock) {
        qtyInput.value = stock;
        showInvWarning('Only ' + stock + ' left in stock!');
      } else {
        qtyInput.value = next;
        if (stock > 5 || stock === Infinity) hideInvWarning();
      }
    });
    qtyInput.addEventListener('change', () => {
      const stock = getVariantStock(findVariant());
      let val = Math.max(1, parseInt(qtyInput.value) || 1);
      if (stock < Infinity && val > stock) {
        val = Math.max(1, stock);
        showInvWarning('Only ' + stock + ' left in stock!');
      } else if (stock > 5 || stock === Infinity) {
        hideInvWarning();
      }
      qtyInput.value = val;
    });
    // Block form submit when qty exceeds stock
    qtyInput.closest('form')?.addEventListener('submit', function(e) {
      const stock = getVariantStock(findVariant());
      const qty = parseInt(qtyInput.value) || 1;
      if (stock < Infinity && qty > stock) {
        e.preventDefault();
        qtyInput.value = Math.max(1, stock);
        showInvWarning('Only ' + stock + ' left in stock!');
      }
    });
  }

  // Mobile dot click handlers
  document.querySelectorAll('#gallery-mobile-dots .mobile-dot').forEach(dot => {
    dot.addEventListener('click', () => {
      const idx = parseInt(dot.dataset.dotIndex);
      if (data.images[idx]) setMainImage(data.images[idx].src, data.images[idx].alt, idx);
    });
  });

  // Touch swipe — attach to main-image for reliable iOS touch capture
  if (data.images.length > 1) {
    const swipeTarget = document.getElementById('main-image') || document.querySelector('.gallery');
    if (swipeTarget) {
      let touchStartX = 0;
      let touchStartY = 0;
      swipeTarget.addEventListener('touchstart', e => {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, { passive: true });
      swipeTarget.addEventListener('touchend', e => {
        const dx = e.changedTouches[0].clientX - touchStartX;
        const dy = e.changedTouches[0].clientY - touchStartY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          const idx = dx < 0
            ? (currentImgIndex + 1) % data.images.length
            : (currentImgIndex - 1 + data.images.length) % data.images.length;
          setMainImage(data.images[idx].src, data.images[idx].alt, idx);
        }
      }, { passive: true });
    }
  }
})();

// ============ CART PAGE ============
(function() {
  if (!document.querySelector('.cart-page')) return;

  const cartState = { discountCode: null, discountAmount: 0 };

  function money(n) { return getCurrencySymbol() + n.toFixed(2).replace(/\.00$/, ''); }

  async function cartChange(key, quantity) {
    try {
      // FormData, not JSON — Meta's in-app browser (Instagram/Facebook)
      // mishandles fetch() calls with a JSON body; see apiAdd() in
      // cart-drawer.js for the full explanation.
      var fd = new FormData();
      fd.append('id', key);
      fd.append('quantity', quantity);
      await fetch('/cart/change.js', { method: 'POST', body: fd });
    } catch (_) {}
  }

  function bindQty(item) {
    const down = item.querySelector('.qty-down');
    const up = item.querySelector('.qty-up');
    const input = item.querySelector('.qty-val');
    if (!down || !up || !input) return;
    const updateQty = (newQty) => {
      newQty = Math.max(1, parseInt(newQty) || 1);
      input.value = newQty;
      item.dataset.qty = newQty;
      const base = parseFloat(item.dataset.basePrice) || 0;
      const cust = parseFloat(item.dataset.customizePrice) || 0;
      const lineTotal = (base + cust) * newQty;
      const priceEl = item.querySelector('.cart-item-price');
      if (priceEl) priceEl.textContent = money(lineTotal);
      recalculate();
      cartChange(input.dataset.key, newQty);
    };
    down.addEventListener('click', () => updateQty(parseInt(input.value) - 1));
    up.addEventListener('click', () => updateQty(parseInt(input.value) + 1));
    input.addEventListener('change', () => updateQty(input.value));
  }
  document.querySelectorAll('.cart-item').forEach(bindQty);

  function showToast(msg) {
    let toast = document.getElementById('cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'cart-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add('visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(() => toast.classList.remove('visible'), 2500);
  }

  document.querySelectorAll('.remove-item').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.cart-item');
      cartChange(btn.dataset.key, 0);
      item.remove();
      recalculate();
      checkEmpty();
      showToast('Item removed from cart');
    });
  });

  document.querySelectorAll('.save-later').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1.1L12 21l7.8-7.5 1-1.1a5.5 5.5 0 0 0 0-7.8Z"/></svg> Saved';
      btn.style.color = 'var(--red)';
      btn.disabled = true;
    });
  });

  const DISCOUNT_CODES = { 'WELCOME10': 0.10, 'BJJFAM': 0.15, 'OSS5': 0.05 };

  function setCheckoutDiscount(code) {
    cartState.discountCode = code || null;
  }

  const checkoutBtn = document.querySelector('.checkout-btn');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function(e) {
      if (cartState.discountCode) {
        e.preventDefault();
        window.location.href = '/checkout?discount=' + encodeURIComponent(cartState.discountCode);
      }
    });
  }

  function applyDiscount(code) {
    const knownRate = DISCOUNT_CODES[code];
    cartState.discountCode = code;
    cartState.discountAmount = knownRate || 0;
    try { localStorage.setItem('fl_discount_code', code); } catch (e) {}
    setCheckoutDiscount(code);
    const row = document.getElementById('discount-row');
    const nameEl = document.getElementById('discount-name');
    const input = document.getElementById('discount-code');
    const applyBtn = document.getElementById('discount-apply-btn');
    const clearBtn = document.getElementById('discount-clear');
    const pending = document.getElementById('discount-pending');
    if (input) { input.value = code; input.readOnly = true; }
    if (clearBtn) clearBtn.style.display = '';
    if (knownRate) {
      if (row) row.style.display = 'flex';
      if (nameEl) nameEl.textContent = code;
      if (applyBtn) { applyBtn.textContent = 'Applied ✓'; applyBtn.style.background = 'var(--green)'; applyBtn.style.borderColor = 'var(--green)'; }
      if (pending) pending.style.display = 'none';
    } else {
      if (row) row.style.display = 'none';
      if (applyBtn) { applyBtn.textContent = 'Saved ✓'; applyBtn.style.background = 'var(--grey-500)'; applyBtn.style.borderColor = 'var(--grey-500)'; }
      if (pending) pending.style.display = 'block';
    }
    recalculate();
    return true;
  }

  function removeDiscount() {
    cartState.discountCode = null;
    cartState.discountAmount = 0;
   try { localStorage.removeItem('fl_discount_code'); } catch (e) {}
    setCheckoutDiscount(null);
    const row = document.getElementById('discount-row');
    const input = document.getElementById('discount-code');
    const applyBtn = document.getElementById('discount-apply-btn');
    const clearBtn = document.getElementById('discount-clear');
    const pending = document.getElementById('discount-pending');
    if (row) row.style.display = 'none';
    if (input) { input.value = ''; input.readOnly = false; input.focus(); }
    if (applyBtn) { applyBtn.textContent = 'Apply'; applyBtn.style.background = ''; applyBtn.style.borderColor = ''; }
    if (clearBtn) clearBtn.style.display = 'none';
    if (pending) pending.style.display = 'none';
    recalculate();
  }

  document.getElementById('discount-clear')?.addEventListener('click', removeDiscount);

  // Restore saved discount on page load
 try { savedCode = localStorage.getItem('fl_discount_code'); } catch (e) {}
if (savedCode) applyDiscount(savedCode);

  const discountForm = document.getElementById('discount-form');
  if (discountForm) {
    discountForm.addEventListener('submit', e => {
      e.preventDefault();
      const code = document.getElementById('discount-code')?.value.toUpperCase().trim();
      if (!code) return;
      applyDiscount(code);
    });
  }

  document.getElementById('remove-discount')?.addEventListener('click', removeDiscount);

  function recalculate() {
    let subtotal = 0, engravingTotal = 0, totalQty = 0;
    document.querySelectorAll('.cart-item').forEach((item, i) => {
      const base = parseFloat(item.dataset.basePrice) || 0;
      const compare = parseFloat(item.dataset.comparePrice) || 0;
      const cust = parseFloat(item.dataset.customizePrice) || 0;
      const qty = parseInt(item.dataset.qty) || 1;
      const onSale = compare > base;
      const idx = i + 1;
      const lineOriginal = base * qty;
      const lineDiscounted = lineOriginal * (1 - cartState.discountAmount);
      const priceEl = document.getElementById('item-price-' + idx);
      const wasEl = document.getElementById('item-price-was-' + idx);
      const unitEl = document.getElementById('item-price-unit-' + idx);
      if (cartState.discountAmount > 0) {
        if (priceEl) priceEl.textContent = money(lineDiscounted);
        if (wasEl) { wasEl.textContent = money(onSale ? compare * qty : lineOriginal); wasEl.style.display = ''; }
        if (unitEl) unitEl.textContent = money(base * (1 - cartState.discountAmount)) + ' each';
      } else {
        if (priceEl) priceEl.textContent = money(lineOriginal);
        if (wasEl) wasEl.style.display = onSale ? '' : 'none';
        if (unitEl) unitEl.textContent = money(base) + ' each';
      }
      subtotal += base * qty;
      engravingTotal += cust * qty;
      totalQty += qty;
    });
    const discountValue = cartState.discountAmount * (subtotal + engravingTotal);
    const total = subtotal + engravingTotal - discountValue;
    const set = (id, val) => { const el = document.getElementById(id); if (el) el.textContent = val; };
    const setHtml = (id, val) => { const el = document.getElementById(id); if (el) el.innerHTML = val; };
    set('summary-count', '(' + totalQty + ' item' + (totalQty !== 1 ? 's' : '') + ')');
    set('summary-subtotal', money(subtotal));
    set('summary-engraving', money(engravingTotal));
    set('summary-discount', money(discountValue));
    set('summary-total', money(total));
    set('item-count', totalQty + ' item' + (totalQty !== 1 ? 's' : '') + ' in your cart');
    const cartCountEl = document.querySelector('.cart-count');
    if (cartCountEl) cartCountEl.textContent = totalQty;
    const engravingRow = document.getElementById('engraving-row');
    if (engravingRow) engravingRow.style.display = engravingTotal > 0 ? 'flex' : 'none';
  }

  function checkEmpty() {
    const items = document.querySelectorAll('.cart-item');
    const isEmpty = items.length === 0;
    const cartGridEl = document.querySelector('.cart-grid');
    const emptyEl = document.getElementById('empty-cart');
    const itemCountEl = document.getElementById('item-count');
    if (cartGridEl) cartGridEl.style.display = isEmpty ? 'none' : '';
    if (emptyEl) emptyEl.style.display = isEmpty ? 'block' : 'none';
    if (isEmpty && itemCountEl) itemCountEl.textContent = '0 items in your cart';
  }

  recalculate();

  // ============ LIVE SHIPPING RATE ============
  (function fetchShippingRate() {
    const aside = document.querySelector('.summary');
    const zip      = aside?.dataset.shipZip      || 'L1S 3M1';
    const country  = aside?.dataset.shipCountry  || 'Canada';
    const province = aside?.dataset.shipProvince || 'Ontario';
    const url = '/cart/shipping_rates.json'
      + '?shipping_address[zip]='      + encodeURIComponent(zip)
      + '&shipping_address[country]='  + encodeURIComponent(country)
      + '&shipping_address[province]=' + encodeURIComponent(province);
    fetch(url)
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(data => {
        const rates = data.shipping_rates || [];
        if (rates.length === 0) {
          cartState.shippingCost = false;
        } else {
          const lowest = rates.reduce((a, b) => parseFloat(a.price) <= parseFloat(b.price) ? a : b);
          cartState.shippingCost = parseFloat(lowest.price);
          cartState._fetchedRate = cartState.shippingCost;
        }
        recalculate();
      })
      .catch(() => {
        cartState.shippingCost = false;
        recalculate();
      });
  })();

  // ============ DELIVERY METHOD ============
  function saveDeliveryAttrs(attrs) {
    var fd = new FormData();
    Object.keys(attrs).forEach(function(k) { fd.append('attributes[' + k + ']', attrs[k]); });
    fetch('/cart/update.js', { method: 'POST', body: fd });
  }

  function updatePickupReminder(method, locationLabel) {
    const reminder = document.getElementById('checkout-pickup-reminder');
    const msg = document.getElementById('checkout-pickup-msg');
    if (!reminder || !msg) return;
    if (method === 'pickup') {
      msg.innerHTML = 'At checkout, select <strong>Pick up in store</strong>' + (locationLabel ? ' — ' + locationLabel : '') + ' to skip shipping fees.';
      reminder.style.display = 'flex';
    } else if (method === 'event') {
      msg.innerHTML = 'At checkout, select <strong>Pick up in store</strong>. Show your order confirmation at our booth.';
      reminder.style.display = 'flex';
    } else {
      reminder.style.display = 'none';
    }
  }

  document.querySelectorAll('.delivery-option').forEach(opt => {
    opt.addEventListener('click', () => {
      document.querySelectorAll('.delivery-option').forEach(o => o.classList.remove('active'));
      opt.classList.add('active');
      const method = opt.dataset.method;
      cartState.shippingCost = method === 'ship' ? (cartState._fetchedRate ?? false) : 0;
      document.body.classList.remove('delivery-pickup', 'delivery-event');
      if (method === 'pickup') document.body.classList.add('delivery-pickup');
      if (method === 'event') document.body.classList.add('delivery-event');
      recalculate();
      saveDeliveryAttrs({ 'Delivery Method': method });
      updatePickupReminder(method, null);
    });
  });

  document.querySelectorAll('.pickup-loc').forEach(p => {
    p.addEventListener('click', () => {
      const group = p.closest('.pickup-locations, .event-locations');
      group?.querySelectorAll('.pickup-loc').forEach(x => x.classList.remove('active'));
      p.classList.add('active');
      const loc = p.dataset.loc;
      const evt = p.dataset.event;
      const label = p.querySelector('strong')?.textContent || p.querySelector('.event-date-line')?.textContent?.trim() || '';
      const attrs = {};
      if (loc) attrs['Pickup Location'] = p.querySelector('strong')?.textContent || loc;
      if (evt) attrs['Event'] = p.querySelector('.event-date-line')?.textContent?.trim() || evt;
      saveDeliveryAttrs(attrs);
      const method = document.querySelector('.delivery-option.active')?.dataset.method;
      updatePickupReminder(method, label);
    });
  });

  // Restore saved delivery preference from cart attributes on load
  fetch('/cart.js')
    .then(r => r.json())
    .then(data => {
      const attrs = data.attributes || {};
      const pref = attrs['Delivery Method'];
      if (!pref || pref === 'ship') return;
      const btn = document.querySelector(`.delivery-option[data-method="${pref}"]`);
      if (btn) {
        btn.click();
        const loc = attrs['Pickup Location'];
        const evt = attrs['Event'];
        if (loc) {
          document.querySelectorAll('.pickup-loc[data-loc]').forEach(b => {
            if ((attrs['Pickup Location'] || '').toLowerCase().includes(b.dataset.loc)) b.click();
          });
        }
        if (evt) {
          document.querySelectorAll('.pickup-loc[data-event]').forEach(b => {
            if (b.dataset.event === evt) b.click();
          });
        }
      }
    });

  // ============ CART NOTE ============
  const noteEl = document.getElementById('cart-note');
  const noteCount = document.getElementById('cart-note-count');
  const noteSaved = document.getElementById('cart-note-saved');
  if (noteEl) {
    // Clear any note that was auto-generated by the delivery method selector
    if (/^Delivery:/i.test(noteEl.value.trim())) {
      noteEl.value = '';
      var fdClear = new FormData();
      fdClear.append('note', '');
      fetch('/cart/update.js', { method: 'POST', body: fdClear });
    }
    if (noteCount) noteCount.textContent = noteEl.value.length + ' / 500';
    noteEl.addEventListener('input', () => {
      if (noteCount) noteCount.textContent = noteEl.value.length + ' / 500';
    });
    noteEl.addEventListener('blur', () => {
      var fdNote = new FormData();
      fdNote.append('note', noteEl.value);
      fetch('/cart/update.js', { method: 'POST', body: fdNote }).then(() => {
        if (noteSaved) {
          noteSaved.textContent = 'Saved ✓';
          noteSaved.classList.add('visible');
          setTimeout(() => noteSaved.classList.remove('visible'), 2500);
        }
      });
    });
  }

  // ============ CUSTOMIZATION EDIT PANEL ============
  function toggleEditPanel(panelId) {
    const panel = document.getElementById('edit-panel-' + panelId);
    if (!panel) return;
    const isOpen = panel.classList.contains('open');
    document.querySelectorAll('.cust-edit-panel.open').forEach(p => p.classList.remove('open'));
    if (!isOpen) { panel.classList.add('open'); panel.querySelector('input')?.focus(); }
  }

  function saveEdit(itemIdx) {
    const input = document.getElementById('edit-text-' + itemIdx);
    const panel = document.getElementById('edit-panel-' + itemIdx);
    if (!input || !panel) return;
    const newText = input.value.trim().toUpperCase();
    if (!newText) { alert('Please enter text.'); return; }
    const custBlock = panel.previousElementSibling;
    const valEl = custBlock?.querySelector('.text-block');
    if (valEl) valEl.textContent = newText;
    const previewEl = document.getElementById('edit-preview-' + itemIdx);
    if (previewEl) previewEl.textContent = newText;
    panel.classList.remove('open');
    if (custBlock) {
      custBlock.style.transition = 'background 0.3s';
      custBlock.style.background = 'rgba(46,160,67,0.2)';
      setTimeout(() => { custBlock.style.background = ''; }, 800);
    }
  }

  document.querySelectorAll('.cust-edit').forEach(btn => {
    btn.addEventListener('click', () => toggleEditPanel(btn.dataset.panel));
  });
  document.querySelectorAll('.cust-edit-save').forEach(btn => {
    btn.addEventListener('click', () => saveEdit(btn.dataset.item));
  });
  document.querySelectorAll('.cust-edit-cancel').forEach(btn => {
    btn.addEventListener('click', () => {
      const panel = document.getElementById('edit-panel-' + btn.dataset.panel);
      if (panel) panel.classList.remove('open');
    });
  });
  document.querySelectorAll('.cust-edit-field input[type="text"]').forEach(input => {
    input.addEventListener('input', () => {
      const val = input.value.toUpperCase();
      input.value = val;
      const itemIdx = input.id.replace('edit-text-', '');
      const preview = document.getElementById('edit-preview-' + itemIdx);
      if (preview) preview.textContent = val;
    });
  });

  // ── Pickup locations info block ──
  (function loadPickupLocations() {
    var container = document.getElementById('cart-pickup-info');
    var locList   = document.getElementById('cart-pickup-locs');
    if (!container || !locList) return;

    fetch('https://4i6sde-8c.myshopify.com/api/2024-01/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': '056171d52408ef5013a37391b4fd56c4'
      },
      body: JSON.stringify({ query: '{ locations(first: 20) { edges { node { id name address { address1 city } } } } }' })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      console.log('[Pickup] API response:', JSON.stringify(data));
      var edges = (data.data && data.data.locations && data.data.locations.edges) || [];
      if (!edges.length) return;
      locList.innerHTML = edges.map(function(edge) {
        var loc = edge.node;
        var addr = [loc.address && loc.address.address1, loc.address && loc.address.city].filter(Boolean).join(', ');
        return '<li class="cart-pickup-loc">'
          + '<strong>' + loc.name + '</strong>'
          + (addr ? '<span>' + addr + '</span>' : '')
          + '</li>';
      }).join('');
      container.style.display = 'block';
    })
    .catch(function() {});
  })();

})();

/* ============================================================
   GALLERY CAROUSEL
   ============================================================ */
(function () {
  const carousel = document.getElementById('gallery-carousel');
  if (!carousel) return;

  const track   = document.getElementById('gallery-carousel-track');
  const slides  = Array.from(track ? track.querySelectorAll('.gallery-slide') : []);
  const prevBtn = document.getElementById('gallery-prev');
  const nextBtn = document.getElementById('gallery-next');
  const dotsWrap = document.getElementById('gallery-dots');

  if (!slides.length) return;

  const isFade = track.classList.contains('is-fade');
  let current = 0;

  function goTo(idx) {
    if (idx < 0) idx = slides.length - 1;
    if (idx >= slides.length) idx = 0;
    current = idx;

    if (isFade) {
      slides.forEach((s, i) => s.classList.toggle('active', i === idx));
    } else {
      track.style.transform = 'translateX(-' + (100 * idx) + '%)';
    }
    if (dotsWrap) {
      dotsWrap.querySelectorAll('.dot').forEach((d, i) => d.classList.toggle('active', i === idx));
    }
  }

  /* build dots */
  if (dotsWrap) {
    slides.forEach((_, i) => {
      const d = document.createElement('span');
      d.className = 'dot' + (i === 0 ? ' active' : '');
      d.addEventListener('click', () => goTo(i));
      dotsWrap.appendChild(d);
    });
  }

  if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
  if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));

  /* swipe */
  let tx0 = null;
  carousel.addEventListener('touchstart', e => { tx0 = e.touches[0].clientX; }, { passive: true });
  carousel.addEventListener('touchend', e => {
    if (tx0 === null) return;
    const dx = e.changedTouches[0].clientX - tx0;
    if (Math.abs(dx) > 40) goTo(dx < 0 ? current + 1 : current - 1);
    tx0 = null;
  }, { passive: true });

  /* sync when variant JS changes the main image */
  document.addEventListener('gallery:setImage', e => {
    const idx = slides.findIndex(s => {
      const img = s.querySelector('img');
      return img && img.src.includes(e.detail.handle);
    });
    if (idx >= 0) goTo(idx);
  });
})();

/* ============================================================
   LIGHTBOX
   ============================================================ */
(function () {
  const lb = document.getElementById('img-lightbox');
  if (!lb) return;

  const img     = document.getElementById('lightbox-img');
  const counter = document.getElementById('lightbox-counter');
  const prevBtn = document.getElementById('lightbox-prev');
  const nextBtn = document.getElementById('lightbox-next');
  const closeBtn = document.getElementById('lightbox-close');

  const pd = window.ProductData || {};
  const images = pd.images || [];
  let current = 0;

  function open(idx) {
    current = (idx + images.length) % images.length;
    if (img) img.src = images[current] || '';
    if (counter) counter.textContent = (current + 1) + ' / ' + images.length;
    lb.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    lb.classList.remove('open');
    document.body.style.overflow = '';
  }

  function shift(delta) { open(current + delta); }

  if (prevBtn) prevBtn.addEventListener('click', e => { e.stopPropagation(); shift(-1); });
  if (nextBtn) nextBtn.addEventListener('click', e => { e.stopPropagation(); shift(1); });
  if (closeBtn) closeBtn.addEventListener('click', close);
  lb.addEventListener('click', e => { if (e.target === lb) close(); });

  document.addEventListener('keydown', e => {
    if (!lb.classList.contains('open')) return;
    if (e.key === 'Escape')     close();
    if (e.key === 'ArrowLeft')  shift(-1);
    if (e.key === 'ArrowRight') shift(1);
  });

  /* open triggers from main gallery */
  document.addEventListener('click', e => {
    const mainImg = e.target.closest('.gallery--action-lightbox .main-image');
    if (mainImg) {
      const src = mainImg.querySelector('img')?.src || '';
      const idx = images.findIndex(u => src.includes(u.split('?')[0].split('/').pop().split('_')[0]));
      open(idx >= 0 ? idx : 0);
    }
    const zoomBtn = e.target.closest('.zoom-btn');
    if (zoomBtn) {
      const wrap = zoomBtn.closest('[data-action="lightbox"]') || zoomBtn.closest('[data-zoom-type="type2"]');
      if (wrap) {
        const src = wrap.querySelector('.main-image img')?.src || '';
        const idx = images.findIndex(u => src.includes(u.split('?')[0].split('/').pop().split('_')[0]));
        open(idx >= 0 ? idx : 0);
      }
    }
  });
})();

/* ============================================================
   PRODUCT CAROUSEL (related / complete-the-look)
   ============================================================ */
(function () {
  document.querySelectorAll('.prod-carousel').forEach(initCarousel);

  function initCarousel(wrap) {
    const track  = wrap.querySelector('.prod-carousel-track');
    const inner  = wrap.querySelector('.prod-carousel-inner');
    const dotsEl = wrap.querySelector('.prod-carousel-dots');
    if (!track) return;

    const realItems = Array.from(track.children);
    const effect    = wrap.dataset.effect  || 'slide';
    const showDots  = wrap.dataset.dots !== 'false';
    let perPage      = getPerPage();
    let rawItem      = 0;   // item-index position; can go outside [0, n-1] while in clone buffer
    let currentItem  = 0;   // normalized real item index (0..realItems.length-1)
    let looping      = false;

    if (effect === 'fade') track.classList.add('is-fade');

    function getPerPage() {
      if (!inner) return 4;
      const w = inner.offsetWidth;
      if (w < 400) return 1;
      if (w < 640) return 2;
      if (w < 900) return 3;
      return 4;
    }

    function pages() { return Math.ceil(realItems.length / perPage); }

    function clearClones() {
      track.querySelectorAll('.prod-carousel-clone').forEach(el => el.remove());
    }

    /* Clone the full item set on both ends so stepping one page past either
       boundary always lands on real-looking content instead of blank space. */
    function sizeItems() {
      wrap.style.setProperty('--c-pp', perPage);
    }

    function buildClones() {
      clearClones();
      looping = effect !== 'fade' && realItems.length > perPage;
      if (!looping) return;

      const leadFrag = document.createDocumentFragment();
      realItems.forEach(el => {
        const clone = el.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.style.pointerEvents = 'none';
        clone.classList.add('prod-carousel-clone');
        leadFrag.appendChild(clone);
      });
      track.insertBefore(leadFrag, track.firstChild);

      const trailFrag = document.createDocumentFragment();
      realItems.forEach(el => {
        const clone = el.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.style.pointerEvents = 'none';
        clone.classList.add('prod-carousel-clone');
        trailFrag.appendChild(clone);
      });
      track.appendChild(trailFrag);
    }

    function itemWidth() {
      return realItems[0] ? realItems[0].offsetWidth + 16 : 0;
    }

    function baseOffset() {
      return looping && realItems[0] ? realItems[0].offsetLeft : 0;
    }

    function applyTransform(ri, animate) {
      const shift = Math.max(0, baseOffset() + itemWidth() * ri);
      track.style.transition = animate ? '' : 'none';
      track.style.transform  = 'translateX(-' + shift + 'px)';
      if (!animate) {
        void track.offsetHeight; // force reflow before re-enabling the transition
        track.style.transition = '';
      }
    }

    function goTo(itemIdx) {
      const n = realItems.length;

      if (looping) {
        rawItem     = itemIdx;
        currentItem = ((itemIdx % n) + n) % n;
        applyTransform(rawItem, true);
      } else {
        rawItem     = Math.max(0, Math.min(itemIdx, n - 1));
        currentItem = rawItem;
        applyTransform(rawItem, true);
      }

      if (effect === 'fade') {
        realItems.forEach((el, i) => el.classList.toggle('active', i === currentItem));
      }

      if (dotsEl) {
        const dotIdx = Math.floor(currentItem / perPage);
        dotsEl.querySelectorAll('.dot').forEach((d, i) => d.classList.toggle('active', i === dotIdx));
      }
    }

    /* once a clone-buffer slide finishes, silently snap back to the equivalent real item */
    track.addEventListener('transitionend', e => {
      if (e.propertyName !== 'transform' || !looping) return;
      if (rawItem < 0 || rawItem >= realItems.length) {
        rawItem = currentItem;
        applyTransform(rawItem, false);
      }
    });

    /* wire up nav buttons — step 1 item at a time */
    const prevBtn = wrap.querySelector('.prod-carousel-btn--prev, .prod-carousel-btn.prev');
    const nextBtn = wrap.querySelector('.prod-carousel-btn--next, .prod-carousel-btn.next');
    if (prevBtn) prevBtn.addEventListener('click', () => goTo(rawItem - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(rawItem + 1));

    /* build dots (one dot per page-group of perPage items) */
    if (showDots && dotsEl && pages() > 1) {
      dotsEl.innerHTML = '';
      for (let i = 0; i < pages(); i++) {
        const d = document.createElement('span');
        d.className = 'dot' + (i === 0 ? ' active' : '');
        d.addEventListener('click', () => goTo(i * perPage));
        dotsEl.appendChild(d);
      }
    }

    /* swipe — also 1 item at a time */
    let tx0 = null;
    (inner || wrap).addEventListener('touchstart', e => { tx0 = e.touches[0].clientX; }, { passive: true });
    (inner || wrap).addEventListener('touchend', e => {
      if (tx0 === null) return;
      const dx = e.changedTouches[0].clientX - tx0;
      if (Math.abs(dx) > 40) goTo(rawItem + (dx < 0 ? 1 : -1));
      tx0 = null;
    }, { passive: true });

    /* re-init on resize */
    window.addEventListener('resize', () => {
      const newPP = getPerPage();
      if (newPP !== perPage) { perPage = newPP; sizeItems(); buildClones(); goTo(0); }
    });

    sizeItems();
    buildClones();
    goTo(0);
  }
})();

// Footer accordion (mobile only)
(function() {
  document.querySelectorAll('.footer-col').forEach(function(col) {
    var h4 = col.querySelector('h4');
    if (!h4) return;
    var chevron = document.createElement('span');
    chevron.className = 'accordion-chevron';
    chevron.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>';
    h4.appendChild(chevron);
    h4.addEventListener('click', function() {
      if (window.innerWidth > 560) return;
      col.classList.toggle('open');
    });
  });
})();

// ============ COLLECTION & SEARCH PAGE ============
(function() {
  var grid = document.getElementById('coll-grid');
  if (!grid) return;

  // ── Grid toggle ──
  var page = grid.closest('.coll-page');
  var isMobile = function() { return window.innerWidth <= 767; };

  function setGrid(cols) {
    if (!page) return;
    if (isMobile()) {
      page.style.setProperty('--coll-m-cols', cols);
      grid.dataset.mCols = cols;
    } else {
      page.style.setProperty('--coll-d-cols', cols);
      grid.dataset.dCols = cols;
    }
    // Update active button
    var activeCols = isMobile() ? (grid.dataset.mCols || grid.dataset.defaultMCols || '2') : (grid.dataset.dCols || grid.dataset.defaultDCols || '4');
    document.querySelectorAll('.coll-grid-btn').forEach(function(btn) {
      btn.classList.toggle('active', btn.dataset.cols === String(activeCols));
    });
  }

  // Mark initial active button
  var initCols = isMobile() ? (grid.dataset.mCols || '2') : (grid.dataset.dCols || '4');
  document.querySelectorAll('.coll-grid-btn').forEach(function(btn) {
    btn.classList.toggle('active', btn.dataset.cols === initCols);
  });

  document.querySelectorAll('.coll-grid-btn').forEach(function(btn) {
    btn.addEventListener('click', function() { setGrid(btn.dataset.cols); });
  });

  // ── Sort redirect ──
  var sortEl = document.getElementById('coll-sort');
  if (sortEl) {
    sortEl.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortEl.value);
      window.location.href = url.toString();
    });
  }

  // ── Desktop pill dropdowns ──
  document.querySelectorAll('.coll-pill').forEach(function(pill) {
    var btn = pill.querySelector('.coll-pill-btn');
    if (!btn) return;
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      var isOpen = pill.classList.toggle('open');
      btn.setAttribute('aria-expanded', isOpen);
      document.querySelectorAll('.coll-pill.open').forEach(function(other) {
        if (other !== pill) { other.classList.remove('open'); other.querySelector('.coll-pill-btn').setAttribute('aria-expanded', 'false'); }
      });
    });
  });
  document.addEventListener('click', function() {
    document.querySelectorAll('.coll-pill.open').forEach(function(pill) {
      pill.classList.remove('open');
      var btn = pill.querySelector('.coll-pill-btn');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  });

  // ── Mobile filter drawer ──
  var drawerBtn = document.getElementById('coll-filters-btn');
  var drawer = document.getElementById('coll-drawer');
  var overlay = document.getElementById('coll-drawer-overlay');
  var drawerClose = document.getElementById('coll-drawer-close');
  var drawerApply = document.getElementById('coll-drawer-apply');

  function openDrawer() {
    if (drawer) drawer.removeAttribute('aria-hidden');
    if (overlay) overlay.removeAttribute('aria-hidden');
    if (drawerBtn) drawerBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.setAttribute('aria-hidden', 'true');
    if (drawerBtn) drawerBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  if (drawerBtn) drawerBtn.addEventListener('click', openDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (drawerApply) drawerApply.addEventListener('click', closeDrawer);

  // ── Drawer accordion ──
  document.querySelectorAll('.coll-drawer-filter-head').forEach(function(head) {
    head.addEventListener('click', function() {
      var filter = head.closest('.coll-drawer-filter');
      var isOpen = filter.classList.toggle('open');
      head.setAttribute('aria-expanded', isOpen);
    });
  });
})();

// ── Search Overlay ──
(function() {
  var trigger      = document.getElementById('search-trigger');
  var overlay      = document.getElementById('search-overlay');
  var backdrop     = document.getElementById('search-backdrop');
  var input        = document.getElementById('search-overlay-input');
  var closeBtn     = document.getElementById('search-overlay-close');
  var resultsState = document.getElementById('search-results-state');

  if (!trigger || !overlay) return;

  var debounce, lastQ = '';

  function openOverlay() {
    overlay.classList.add('open');
    overlay.removeAttribute('aria-hidden');
    if (backdrop) { backdrop.style.opacity = '1'; backdrop.style.visibility = 'visible'; backdrop.style.pointerEvents = 'auto'; }
    trigger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    setTimeout(function() { if (input) input.focus(); }, 60);
  }

  function closeOverlay() {
    overlay.classList.remove('open');
    overlay.setAttribute('aria-hidden', 'true');
    if (backdrop) { backdrop.style.opacity = '0'; backdrop.style.visibility = 'hidden'; backdrop.style.pointerEvents = 'none'; }
    trigger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (input) input.value = '';

    if (resultsState) { resultsState.hidden = true; resultsState.innerHTML = ''; }
    clearTimeout(debounce);
    lastQ = '';
  }

  function showResults(html) {
    if (resultsState) { resultsState.hidden = false; resultsState.innerHTML = html; }
  }

  function money(val) {
    if (val == null || val === '') return '';
    var raw = typeof val === 'number' ? val : parseFloat(String(val).replace(/[^\d.]/g, ''));
    if (isNaN(raw)) return '';
    var dollars = (Number.isInteger(raw) && raw > 99) ? raw / 100 : raw;
    return getCurrencySymbol() + (dollars % 1 === 0 ? Math.round(dollars) : dollars.toFixed(2));
  }

  function highlight(text, q) {
    var i = text.toLowerCase().indexOf(q.toLowerCase());
    if (i === -1) return text;
    return text.slice(0, i) + '<mark>' + text.slice(i, i + q.length) + '</mark>' + text.slice(i + q.length);
  }

  function render(q, results) {
    var queries  = (results && results.queries)  || [];
    var products = (results && results.products) || [];

    if (!queries.length && !products.length) {
      showResults('<p class="search-no-results">No results for "<strong>' + q + '</strong>"</p>');
      return;
    }

    var html = '';
    var svgSearch = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="15" height="15"><circle cx="11" cy="11" r="7"/><path d="m20 20-4-4"/></svg>';

    var svgArrow = '<svg class="sug-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><path d="M5 12h14m-6-6 6 6-6 6"/></svg>';

    if (queries.length) {
      html += '<div class="search-results-section"><div class="search-section-head">Suggestions</div>';
      queries.slice(0, 4).forEach(function(qr) {
        html += '<a class="search-suggestion-item" href="/search?q=' + encodeURIComponent(qr.text) + '&type=product">';
        html += svgSearch;
        html += '<span class="search-suggestion-text">' + highlight(qr.text, q) + '</span>';
        html += svgArrow;
        html += '</a>';
      });
      html += '</div>';
    }

    if (products.length) {
      html += '<div class="search-results-section"><div class="search-section-head">Products</div>';
      html += '<div class="search-products-grid">';
      products.slice(0, 3).forEach(function(p) {
        var imgSrc = (typeof p.image === 'string' ? p.image : '') || (p.image && (p.image.url || p.image.src)) || (p.featured_image && (p.featured_image.url || p.featured_image.src)) || '';
        var price  = money(p.price || (p.variants && p.variants[0] && p.variants[0].price));
        html += '<a class="search-product-card" href="' + p.url + '">';
        html += '<div class="search-product-img' + (imgSrc ? '' : ' search-product-img--empty') + '">';
        if (imgSrc) {
          html += '<img src="' + imgSrc + '" alt="' + p.title + '" width="300" height="300" loading="lazy">';
        } else {
          html += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" width="32" height="32"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="m21 15-5-5L5 21"/></svg>';
        }
        html += '</div>';
        html += '<div class="search-product-title">' + highlight(p.title, q) + '</div>';
        if (price) html += '<div class="search-product-price">' + price + '</div>';
        html += '</a>';
      });
      html += '</div></div>';
    }

    html += '<a class="search-view-all" href="/search?q=' + encodeURIComponent(q) + '&type=product">';
    html += '<span>View All Results</span>';
    html += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';
    html += '</a>';

    showResults(html);
  }

  function fetchSuggestions(q) {
    if (q === lastQ) return;
    lastQ = q;
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,query&resources[limit]=6';
    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(data) {
        if (data && data.resources && data.resources.results) render(q, data.resources.results);
      })
      .catch(function() {});
  }

  trigger.addEventListener('click', function() {
    overlay.classList.contains('open') ? closeOverlay() : openOverlay();
  });

  if (closeBtn) closeBtn.addEventListener('click', closeOverlay);
  if (backdrop) backdrop.addEventListener('click', closeOverlay);

  if (input) {
    input.addEventListener('input', function() {
      var q = this.value.trim();
      clearTimeout(debounce);
      if (q.length < 2) { if (resultsState) { resultsState.hidden = true; resultsState.innerHTML = ''; } lastQ = ''; return; }
      debounce = setTimeout(function() { fetchSuggestions(q); }, 260);
    });
    input.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeOverlay();
    });
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.classList.contains('open')) closeOverlay();
  });
})();

/* ============================================================
   MAGNET BUILDER — move only upload section, hide conflicting buttons
   ============================================================ */
(function() {
  var anchor = document.getElementById('magnet-upload-anchor');
  if (!anchor) return;

  function setup() {
    var block = document.getElementById('magnet-builder-block') || document.getElementById('magnet-builder-app');
    if (!block) return false;

    // Move the upload section (first child) to the anchor
    var uploadSection = block.firstElementChild;
    if (!uploadSection || anchor.contains(uploadSection)) return false;
    anchor.appendChild(uploadSection);

    // Hide remaining children of the block (conflicting cart/wishlist buttons)
    Array.from(block.children).forEach(function(el) {
      el.style.display = 'none';
    });
    block.style.display = 'none';

    return true;
  }

  if (setup()) return;

  var obs = new MutationObserver(function() {
    if (setup()) obs.disconnect();
  });
  obs.observe(document.body, { childList: true, subtree: true });
})();
